import { Paper, Autocomplete, Button, Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TableContainer, TextField, Table, TableHead, TableRow, TableCell, TableBody, Checkbox, Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { validateUpdateInvoices, validateInvoiceLine } from '../../../../utils/validation'
import { updateInvoice } from '../../../../redux/actions/InvoicesActions'
import useAlert from '../../../../hooks/useAlert';
import { useDispatch, useSelector } from 'react-redux'
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { InvoiceCustomerAddPopUpModal } from './InvoiceCustomerAddPopUpModal'
import SaveIcon from '@mui/icons-material/Save';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

export const InvoicesUpdatePopUpModal = ({ openDialog, handleCloseDialog, data }) => {

  const authUserId = useSelector(state => state?.auth?.user?.id);
  const [invoiceValue, setInvoiceValue] = useState({
    issueDate: '',
    paymentMeansCode: '',
    number: '',
    orderNumber: '',
    type: '',
    currencyCode: '',
    status: '',
    paymentDueDate: '',
    note: '',
    invoiceCustomer: '',
    recordType: ''

  });
  const [lineItems, setLineItems] = useState([{
    unitCode: '',
    inventoryCard: '',
    quantity: '',
    price: '',
    vatRate: 0,
    discountRate: 0,
    discountAmount: '',
    vatIncluded: true,
    lineExtensionAmount: 0,
  }]);
  const addLineItem = () => {
    setLineItems([...lineItems, {
      unitCode: '',
      inventoryCard: '',
      quantity: '',
      price: '',
      vatRate: 0,
      discountRate: 0,
      discountAmount: '',
      vatIncluded: true,
      lineExtensionAmount: 0,
    }]);
  };
  // sayfa yüklenince invoice sayfasından gelen data bu sayfada kullanılır 
  useEffect(() => {
    setInvoiceValue(prevState => ({
      ...prevState,
      ...data,
      invoiceCustomer: data?.invoiceCustomer
    }));
    setLineItems(data?.invoiceLines);
  }, [data]);
  const handleInputChangeUser = (event, value) => {
    setInvoiceValue((prevState) => ({
      ...prevState,
      invoiceCustomer: value,
    }));
  };
  const [openDialogCustomer, setOpenDialogCustomer] = useState(false);
  const handleOpenModal = () => {
    setOpenDialogCustomer(true);
  };

  const { invoicesCustomer } = useSelector(state => state.invoicesCustomer);
  //ürün tutarı hesaplanıyor
  const handleLineItemChange = (index, field, value) => {
    const newLineItems = [...lineItems];
    newLineItems[index][field] = value;

    if (field === 'quantity' || field === 'price' || field === 'vatRate' || field === 'discountRate' || field === 'vatIncluded') {
      const item = newLineItems[index];
      const subtotal = item.quantity * item.price;
      const discountAmount = subtotal * (item.discountRate / 100);
      item.discountAmount = discountAmount;
      let lineExtensionAmount;
      if (item.vatIncluded) {
        const vatAmount = (subtotal - discountAmount) * (item.vatRate / 100);
        lineExtensionAmount = subtotal - discountAmount + vatAmount;
      } else {
        lineExtensionAmount = subtotal - discountAmount;
      }

      item.lineExtensionAmount = lineExtensionAmount;

    }

    setLineItems(newLineItems);
  };
  const { showSuccessUpdateInvoices, showErrorAlertUpdateInvoices } = useAlert();
  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInvoiceValue((prevUserValue) => ({
      ...prevUserValue,
      [name]: value
    }));
    setFormErrors({ ...formErrors, [name]: '' });
  };
  //güncelleme işlemini yapıyor
  const updateInvoices = async (e) => {
    e.preventDefault();
    //fatura detayları
    invoiceValue.invoiceLines = lineItems;
    //faturanın kesildiği müşteri değişirse atama yapılıyor
    invoiceValue.userOfCustomerId = invoiceValue.invoiceCustomer.id;
    //fatura oluşturan kişi
    invoiceValue.userId = authUserId;
    //manuel fatura olduğunu belirtiyorum
    invoiceValue.invoiceRecordType = 1;
    invoiceValue.userOfCustomer = {};
    invoiceValue.totalAmount = lineItems.reduce((total, item) => {
      return total + (item.ia != false ? item.lineExtensionAmount : 0);
    }, 0);
    setFormErrors({});
    const invoiceErrors = validateUpdateInvoices(invoiceValue);
    const lineErrors = validateInvoiceLine(invoiceValue);
    const combinedErrors = {
      ...invoiceErrors,
      ...lineErrors
    };

    setFormErrors(combinedErrors);
    if (Object.keys(invoiceErrors).length === 0 && Object.keys(lineErrors).length === 0) {
      try {
        await dispatch(updateInvoice(invoiceValue))
        handleCloseDialog();
        showSuccessUpdateInvoices();
      } catch (err) {
        showErrorAlertUpdateInvoices();
        console.error("ınvoice update failed:", err);
      }
    }
  };
  //silme işlemi sadece ia yı false yapıyor ia sı false olanlar daha soluk görünecek şekilde ayarlandı kayıt edilirse backende ia kısmı güncelleniyor
  const removeLineItem = (index) => {
    const newLineItems = lineItems?.map((item, i) => {
      if (i === index) {
        if (item.id) {
          return { ...item, ia: !item.ia };
        } else {
          return null;
        }
      }
      return item;
    }).filter(item => item !== null);

    setLineItems(newLineItems);
  };
  return (
    <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
        <Box
                sx={{
                    padding: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 3,
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: 4, height: 24, backgroundColor: '#b71c1c', mr: 1 }} />
                    <Typography
                        variant="h6"
                        color="black"
                        sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}
                    >
                       Fatura Düzenle
                    </Typography>
                </Box>
            </Box>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={9} >
            <Autocomplete
              size='small'
              fullWidth
              options={invoicesCustomer}
              getOptionLabel={(option) => option.name}
              onChange={handleInputChangeUser}
              value={invoiceValue.invoiceCustomer || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Müşteri"
                  variant="outlined"
                  error={!!formErrors.customerData}
                  helperText={formErrors.customerData}
                />
              )}
            />
          </Grid>
          <Grid item xs={2} md={3}>
            <Button
              sx={{
                height: '40px',
                borderRadius: 18,
                backgroundColor: '#1F1B45',
                color: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                padding: '10px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                '&:hover': {
                  backgroundColor: '#2C285A',
                },
              }}
        
              variant="contained"
              size="small"
              startIcon={<PersonAddAltIcon />}
              onClick={handleOpenModal}
            >
              Yeni müşteri ekle
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size='small'

              name='issueDate'
              value={invoiceValue.issueDate}
              onChange={handleInputChange}
              fullWidth
              label="Düzenlenme Tarihi ve Saati"
              variant="outlined"
              type="datetime-local"
              InputLabelProps={{
                shrink: true,
              }}
              error={!!formErrors.issueDate}
              helperText={formErrors.issueDate}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <FormControl fullWidth>
              <InputLabel>Ödeme Yöntemi</InputLabel>
              <Select name='paymentMeansCode'
                value={invoiceValue.paymentMeansCode}
                onChange={handleInputChange} defaultValue=""
                error={!!formErrors.paymentMeansCode}
                helperText={formErrors.paymentMeansCode}>
                <MenuItem value="1">Ödeme Aracısı</MenuItem>
                <MenuItem value="2">Kapıda Ödeme</MenuItem>
                <MenuItem value="3">EFT/Havale</MenuItem>
                <MenuItem value="4">Kredi Kartı/Banka Kartı</MenuItem>
                <MenuItem value="5">Diğer</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              size='small'

              error={!!formErrors.number}
              helperText={formErrors.number}
              fullWidth
              name='number'
              value={invoiceValue.number}
              onChange={handleInputChange}
              label="Fatura No"
              variant="outlined"
              placeholder="Fatura No"
            />
          </Grid>
          {/* <Grid item xs={12} md={6}>
        <TextField 
 size='small'

          error={!!formErrors.orderNumber}
          helperText={formErrors.orderNumber}
          fullWidth
          name='orderNumber'
          value={invoiceValue.orderNumber}
          onChange={handleInputChange}
          label="Sipariş No"
          variant="outlined"
          placeholder="Sipariş No"
        />
      </Grid> */}
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Fatura Türü</InputLabel>
              <Select
                error={!!formErrors.type}
                helperText={formErrors.type}
                name='type'
                value={invoiceValue.type}
                onChange={handleInputChange} defaultValue="">
                <MenuItem value="1">Satış</MenuItem>
                <MenuItem value="2">İade</MenuItem>
                <MenuItem value="3">İstisna</MenuItem>
                <MenuItem value="4">Özel Matrah</MenuItem>
                <MenuItem value="5">Tevkiyat</MenuItem>
                <MenuItem value="6">İhracat kayıtı</MenuItem>
                <MenuItem value="7">SGK</MenuItem>
                <MenuItem value="8">Komisyoncu</MenuItem>
                <MenuItem value="9">Hal tipi satış</MenuItem>
                <MenuItem value="10">Hal Tipi Komisyoncu</MenuItem>
                <MenuItem value="11">Teckiyat iade Faturası</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Para Birimi</InputLabel>
              <Select
                error={!!formErrors.currencyCode}
                helperText={formErrors.currencyCode}
                name='currencyCode'
                value={invoiceValue.currencyCode}
                onChange={handleInputChange} defaultValue="">
                <MenuItem value="TL">Türk Lirası (TL)</MenuItem>
                <MenuItem value="USD">Amerikan Doları (USD)</MenuItem>
                <MenuItem value="EUR">Euro (EUR)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Durum</InputLabel>
              <Select
                error={!!formErrors.status}
                helperText={formErrors.status}
                name='status'
                value={invoiceValue.status}
                onChange={handleInputChange} defaultValue="">
                <MenuItem value="1">Taslak</MenuItem>
                <MenuItem value="2">Imzali</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              size='small'

              fullWidth
              error={!!formErrors.paymentDueDate}
              helperText={formErrors.paymentDueDate}
              name='paymentDueDate'
              value={invoiceValue.paymentDueDate}
              onChange={handleInputChange}
              label="Ödeme vade tarihi"
              variant="outlined"
              type="datetime-local"
              InputLabelProps={{
                shrink: true,
              }}

            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Fatura kayıt tipi</InputLabel>
              <Select
                error={!!formErrors.recordType}
                helperText={formErrors.recordType}
                name='recordType'
                value={invoiceValue.recordType}
                onChange={handleInputChange} defaultValue="">
                <MenuItem value="1">E-Arşiv</MenuItem>
                <MenuItem value="2">E-Fatura</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size='small'

              fullWidth
              name='note'
              error={!!formErrors.note}
              helperText={formErrors.note}
              value={invoiceValue.note}
              onChange={handleInputChange}
              label="Açıklama"
              variant="outlined"
              placeholder="Hareketle ilgili açıklama..."
              multiline
              rows={3}
            />
          </Grid>
          <TableContainer component={Paper}
            sx={{
              mt: 2,
              ml: 2,

            }}>
            <Table>
              <TableHead>
                <TableRow sx={{ background: "lightgrey" }}>
                  <TableCell>Mal/Hizmet</TableCell>
                  <TableCell>Stok Kodu</TableCell>
                  <TableCell >Miktar</TableCell>
                  <TableCell>Birim Fiyat</TableCell>
                  <TableCell>KDV %</TableCell>
                  <TableCell>İskonto %</TableCell>
                  <TableCell>Kalem Açıklaması</TableCell>
                  <TableCell>Kdv dahil mi?</TableCell>
                  <TableCell>Tutar</TableCell>

                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody >
                {lineItems?.map((item, index) => (
                  <TableRow
                    key={index}
                    style={{ opacity: item?.ia == false ? 0.5 : 1 }}
                  >


                    <TableCell>
                      <TextField
                        size='small'

                        fullWidth
                        InputProps={{
                          style: { width: 115, height: 40 },
                        }}
                        value={item.inventoryCard}
                        onChange={(e) => handleLineItemChange(index, 'inventoryCard', e.target.value)}
                        error={!!formErrors[index]?.inventoryCard}
                        helperText={formErrors[index]?.inventoryCard}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size='small'

                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        fullWidth
                        value={item.unitCode}
                        onChange={(e) => handleLineItemChange(index, 'unitCode', e.target.value)}
                        error={!!formErrors[index]?.unitCode}
                        helperText={formErrors[index]?.unitCode}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size='small'

                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        type="number"
                        value={item.quantity}
                        onChange={(e) => handleLineItemChange(index, 'quantity', parseInt(e.target.value) || 0)}
                        error={!!formErrors[index]?.quantity}
                        helperText={formErrors[index]?.quantity}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size='small'

                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        type="number"
                        value={item.price}
                        onChange={(e) => handleLineItemChange(index, 'price', parseFloat(e.target.value) || 0)}
                        error={!!formErrors[index]?.price}
                        helperText={formErrors[index]?.price}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size='small'

                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        type="number"
                        value={item.vatRate}
                        onChange={(e) => handleLineItemChange(index, 'vatRate', parseInt(e.target.value) || 0)}
                        error={!!formErrors[index]?.vatRate}
                        helperText={formErrors[index]?.vatRate}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size='small'

                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        type="number"
                        value={item.discountRate}
                        onChange={(e) => handleLineItemChange(index, 'discountRate', parseInt(e.target.value) || 0)}
                        error={!!formErrors[index]?.discountRate}
                        helperText={formErrors[index]?.discountRate}
                      />
                    </TableCell>

                    <TableCell>{/*Kalem açıklaması*/}
                      <TextField
                        size='small'

                        InputProps={{
                          style: {
                            width:
                              110, height: 35
                          },
                        }}
                        fullWidth
                        value={item.description}
                        error={!!formErrors[index]?.description}
                        helperText={formErrors[index]?.description}
                        onChange={(e) => handleLineItemChange(index, 'description', e.target.value)}
                      />
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        checked={item.vatIncluded}
                        onChange={(e) => handleLineItemChange(index, 'vatIncluded', e.target.checked)}
                      />
                    </TableCell>
                    <TableCell>{item.lineExtensionAmount.toFixed(2)}</TableCell>
                    <TableCell>
                      <Button
                        onClick={() => {
                          const activeItemsCount = lineItems.filter(item => item.ia).length;
                          if (activeItemsCount === 1 && lineItems[index].ia) {
                            alert("En az bir satır kalmalı .");
                            return;
                          }
                          removeLineItem(index);
                        }}
                        disabled={lineItems.length === 1}
                      >
                        <DeleteIcon size={20} />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Button
            startIcon={<AddIcon />}
            onClick={addLineItem}
            sx={{ mt: 2, ml: 2, color: 'green' }}
          >
            Yeni Satır Ekle
          </Button>

          <Grid container justifyContent="flex-end" sx={{ mt: 4 }}>
            <Button
              sx={{
                borderRadius: 18,
                backgroundColor: '#1F1B45',
                color: '#FFFFFF',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                padding: '10px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                '&:hover': {
                  backgroundColor: '#2C285A',
                },
              }}
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={updateInvoices}
            >
              Kaydet
            </Button>
          </Grid>


        </Grid>
      </DialogContent>
      {/* müşteri ekleme modalı */}
      <InvoiceCustomerAddPopUpModal
        openDialog={openDialogCustomer}
        handleCloseDialog={() => setOpenDialogCustomer(false)} />
    </Dialog>

  )
}
